// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "popup__header-3w79U";
export { _1 as "__esModule", _2 as "popup__header" }
export default { "__esModule": _1, "popup__header": _2 }
